import { createSelector } from 'reselect';
import { selectConfig } from './app';

export const selectServices = createSelector(selectConfig, config => config.services);
export const selectOCAPIConfig = createSelector(selectServices, services => services.ocapi);
export const selectMemberConfig = createSelector(selectServices, services => services.member);
export const selectBonusConfig = createSelector(selectServices, services => services.bonus);
export const selectGspConfig = createSelector(selectServices, services => services.gsp);
